// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"f5a0326e","453":"732d482f","934":"171fdb92"}[chunkId] + ".chunk.js";
};